import { colors } from '../../colors';
var fiveCard = {
  textColor: colors.onyx,
  hoverColor: colors.rust,
  bgColorPara: colors.white,
  bgColor: colors.white,
  cardBgColorB: colors.duskBlue,
  cardBgColorHoverB: colors.white,
  cardCTAColorB: colors.white,
  cardCTAColorHoverB: colors.duskBlue,
  iconColor: colors.white,
  iconColorHover: colors.duskBlue
};
export default fiveCard;